import React, { useState } from "react";
import { PaymentDropdown, Toggle } from "components/common";

const SmartPay = ({
  enabled: en = false,
  accounts = [],
  onToggle = () => {},
  onSelect = () => {},
  initialPaymentMethodId = null
}) => {
  const [enabled, setEnabled] = useState(en);
  const [textOffset, setTextOffset] = useState(0);

  const renderAccountDropdown = () => (
    <div className="mt-3">
      {enabled && (
        <PaymentDropdown
          paymentMethods={accounts}
          defaultElementId={initialPaymentMethodId}
          didSelect={onSelect}
        />
      )}
    </div>
  );

  const renderNotEnoughAccounts = () => (
    <div
      className="text-sm text-gray-primary relative"
      style={{ left: textOffset }}
    >
      More than one account must be linked for SmartPay
    </div>
  );

  const notAllowed = () => {
    setEnabled(true);
    setTimeout(() => {
      setEnabled(false);
    }, 100);
    setTextOffset(2);
    setTimeout(() => {
      setTextOffset(0);
    }, 50);
    setTimeout(() => {
      setTextOffset(2);
    }, 100);
    setTimeout(() => {
      setTextOffset(0);
    }, 150);
  };

  const handleOnChange = e => {
    const { checked } = e.target;
    setEnabled(checked);

    if (!accounts.length) {
      if (checked) notAllowed();
    } else {
      onToggle({ enabled: checked });
      if (checked) {
        if (initialPaymentMethodId)
          onSelect({ ...accounts.find(a => a.id === initialPaymentMethodId) });
        else onSelect({ ...accounts[0] });
      } else if (!checked) onSelect(null);
    }
  };

  return (
    <div className="py-2">
      <span className="font-bold mr-3">SmartPay:</span>
      <Toggle
        active={enabled}
        onChange={handleOnChange}
        displayState
      />
      <span
        className="tooltip ml-2 text-gray-500 text-sm cursor-pointer "
        style={{ borderBottom: 0 }}
      >
        <i className="fas fa-question-circle" />
        <span className="tooltiptext2 text-sm border" style={{ left: -83 }}>
          SmartPay will charge the specified backup payment method if your
          default one is at risk of overdraft
        </span>
      </span>
      {accounts.length ? renderAccountDropdown() : renderNotEnoughAccounts()}
    </div>
  );
};

export default SmartPay;
